import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../global/sub-window/common/common-close-sub-window-buttons';
import { RolePermissionFormVM } from '../role-permission-form.viewmodel';
import { RolePermissionFormItem } from './role-permission-form-item';
import { APPLY_TEXT, CANCEL_TEXT } from '../../../../constants/common-labels.constants';

import './role-form-presentation.scss';

interface IProps {
    vm: RolePermissionFormVM;
    intl: IntlShape;
}

const RolePermissionsFormPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const { intl, vm } = props;

    if (vm.isLoading) {
        return <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form meeting-form'>
                    <FormattedMessage
                        description='Label text'
                        defaultMessage='Loading permission data{suffix}'
                        id='oe.permission.loadingData'
                        values={{
                            suffix: '...'
                        }}
                    />
                </div>
            }
        />;
    }

    return (
        <CommonPopupBodyFooterLayout
            body={
                <div>
                    <div className='oe-form role-form'>
                        {<div className='oe-form__body'>
                            {vm.permissionsTemplate.map(({ title, id, permissions }) => {
                                return (
                                    <RolePermissionFormItem
                                        key={title}
                                        title={title}
                                        id={id}
                                        permissions={permissions}
                                        onPermissionChange={vm.handleTogglePermission}
                                    />
                                );
                            })}
                        </div>
                        }
                    </div>
                </div>
            }
            footer={
                <>
                    {vm.isSaving() &&
                        <span className='oe-popup-layout__footer-status-area'>
                            {intl.formatMessage({
                                id: 'oe.role.roleIsBeingSaved',
                                description: 'Placeholder about saving role',
                                defaultMessage: 'Role is being saved, please wait...',
                            })}
                        </span>
                    }

                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(APPLY_TEXT)}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => vm.handleSubmit(intl)}
                            disabled={vm.isSaving()}
                        />
                        <DefaultCloseSubWindowButton text={intl.formatMessage(CANCEL_TEXT)} />
                    </div>
                </>
            }
        />
    );

}));

export { RolePermissionsFormPresentation };
